const initialState = {
  blogs: [],
  hasMoreBlogs: true,
  lastBlogDocument: null,
};

const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_All_BLOGS":
      return {
        ...state,
        blogs: action.payload.data,
        hasMoreBlogs: action.payload.hasMoreDocument,
        lastBlogDocument: action.payload.lastDocument,
      };
    case "MORE_GET_All_BLOGS":
      return {
        ...state,
        blogs: [...state.blogs, ...action.payload.data],
        hasMoreBlogs: action.payload.hasMoreDocument,
        lastBlogDocument: action.payload.lastDocument,
      };
    case "AddBlog":
      return {
        ...state,
        blogs: [...state.blogs, action.payload],
      };
    case "EDIT_BLOG_DATA":
      let { id, blogData } = action.payload;
      let update = state.blogs.map((items) =>
        items.id == id ? { ...items, ...blogData } : items
      );
      return {
        ...state,
        blogs: update,
      };

    case "DELETE_BLOG":
      let deleteBlog = state.blogs.filter(
        (items) => items.id !== action.payload
      );
      return {
        ...state,
        blogs: deleteBlog,
      };

    default:
      return state;
  }
};
export default blogReducer;
